/**
 * FikoAi3DDialogComponent — "Resimden 3D" (ComfyUI / FikoYT-img2-3d is akisi).
 *
 * Kullanici resim secer -> ComfyUI'a gonderilir -> uretilen dokulu GLB
 * dogrudan aktif sahneye renkli olarak eklenir.
 */
import { Component, Input, ChangeDetectorRef, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { FikoComfyAPI } from './fiko-comfy-api';
import { fikoAi3DSahneyeEkle } from './fiko-ai-3d-yukleyici';
import { fikoGlbBlobundanStl, fikoStlAdi, fikoDosyaIndir } from '../FikoThreeCam/FikoSTLDisaAktar';
import { fikoObjeyiStepIndir, FikoStepModu } from '../FikoThreeCam/FikoSTEPDisaAktar';

@Component({
  selector: 'fikoyt-fiko-ai-3d',
  standalone: true,
  imports: [CommonModule, FormsModule],
  styles: [`
    .fa3-kok { padding: 10px; width: 330px; font-size: 12px; color: #e8eef5; }
    .fa3-sec { border: 1px dashed #4a6f9a; border-radius: 8px; padding: 14px; text-align: center;
               cursor: pointer; background: rgba(255,255,255,.04); }
    .fa3-sec:hover { background: rgba(255,255,255,.09); }
    .fa3-onizleme { width: 100%; max-height: 170px; object-fit: contain; border-radius: 8px;
                    background: #0e1420; margin-top: 8px; }
    .fa3-satir { display:flex; align-items:center; justify-content:space-between; margin-top: 8px; gap: 8px; }
    .fa3-satir label { opacity: .9; }
    .fa3-satir select, .fa3-satir input[type=number] { width: 110px; }
    .fa3-bar { height: 6px; border-radius: 4px; background: #24313f; overflow: hidden; margin-top: 10px; }
    .fa3-bar > i { display:block; height:100%; background: linear-gradient(90deg,#0ea5e9,#22d3ee); transition: width .25s; }
    .fa3-durum { margin-top: 6px; min-height: 16px; opacity: .85; }
    .fa3-hata { margin-top: 6px; color: #ff8a8a; word-break: break-word; }
    .fa3-dugmeler { display:flex; gap:6px; margin-top: 12px; }
    .fa3-not { margin-top: 10px; font-size: 11px; opacity: .6; line-height: 1.4; }
    .fa3-ayirac { height: 1px; background: rgba(255,255,255,.12); margin: 12px 0 4px; }
    .fa3-step-ayar { margin-top: 6px; padding: 8px; border-radius: 6px;
                     background: rgba(255,255,255,.03); border: 1px solid rgba(255,255,255,.08); }
    .fa3-ayar-dugme { padding: 4px 7px !important; }
    .fa3-sonuc { margin-top: 12px; padding: 10px; border-radius: 8px;
                 background: rgba(34,211,238,.08); border: 1px solid rgba(34,211,238,.35); }
    .fa3-sonuc-bas { font-weight: 600; margin-bottom: 2px; color: #7fe7f5; }
    .fa3-sonuc-bilgi { font-size: 11px; opacity: .75; }
    .fa3-yuzde { float: right; opacity: .7; }
  `],
  template: `
  <div class="fa3-kok">
    <div class="fa3-sec" (click)="dosyaSec()">
      <i class="icon image outline"></i>
      {{ dosya ? dosya.name : 'Resim secmek icin tikla (PNG / JPG / WEBP)' }}
    </div>
    <img *ngIf="onizlemeUrl" [src]="onizlemeUrl" class="fa3-onizleme" alt="onizleme">

    <div class="fa3-satir">
      <label><input type="checkbox" [(ngModel)]="arkaPlanSil" [disabled]="calisiyor"> Arka plani sil</label>
    </div>
    <div class="fa3-satir">
      <label>Doku cozunurlugu</label>
      <select [(ngModel)]="dokuCozunurluk" [disabled]="calisiyor">
        <option [ngValue]="1024">1024 (hizli)</option>
        <option [ngValue]="2048">2048</option>
        <option [ngValue]="4096">4096 (kaliteli)</option>
      </select>
    </div>
    <div class="fa3-satir">
      <label>Hedef boyut (mm)</label>
      <input type="number" min="1" max="10000" [(ngModel)]="hedefBoyutMm" [disabled]="calisiyor">
    </div>
    <div class="fa3-satir">
      <label><input type="checkbox" [(ngModel)]="rastgeleSeed" [disabled]="calisiyor"> Her seferinde farkli sonuc</label>
    </div>

    <div class="fa3-ayirac"></div>

    <div class="fa3-satir">
      <label>Sahneye eklenecek</label>
      <select [(ngModel)]="sahneFormat" [disabled]="calisiyor">
        <option value="glb">GLB (renkli)</option>
        <option value="stl">STL (renksiz)</option>
        <option value="yok">Ekleme</option>
      </select>
    </div>
    <div class="fa3-satir">
      <label><input type="checkbox" [(ngModel)]="stlIndir" [disabled]="calisiyor"> Bitince STL dosyasini indir</label>
    </div>
    <div class="fa3-satir">
      <label><input type="checkbox" [(ngModel)]="glbIndir" [disabled]="calisiyor"> Bitince GLB dosyasini indir</label>
    </div>
    <div class="fa3-satir">
      <label><input type="checkbox" [(ngModel)]="stepIndir" [disabled]="calisiyor || sahneFormat === 'yok'"> Bitince STEP dosyasini indir</label>
      <span style="display:flex; align-items:center; gap:6px;">
        <select [(ngModel)]="stepModu" [disabled]="calisiyor || !stepIndir">
          <option value="brep">B-Rep</option>
          <option value="tessellated">AP242 Tessellated</option>
        </select>
        <button class="ui tiny icon button fa3-ayar-dugme" type="button" title="STEP ayarlari"
                (click)="stepAyarlarAcik = !stepAyarlarAcik">
          <i class="icon cog"></i>
        </button>
      </span>
    </div>

    <div class="fa3-step-ayar" *ngIf="stepAyarlarAcik">
      <div class="fa3-satir">
        <label>B-Rep hedef ucgen</label>
        <input type="number" min="0" step="1000" placeholder="sinirsiz"
               [(ngModel)]="stepHedefUcgenBrep" (ngModelChange)="stepAyarlariKaydet()"
               [disabled]="calisiyor || stepCalisiyor">
      </div>
      <div class="fa3-satir">
        <label>Tessellated hedef ucgen</label>
        <input type="number" min="0" step="10000" placeholder="sinirsiz"
               [(ngModel)]="stepHedefUcgenTessellated" (ngModelChange)="stepAyarlariKaydet()"
               [disabled]="calisiyor || stepCalisiyor">
      </div>
      <div class="fa3-satir">
        <label>Kaynak toleransi (mm)</label>
        <input type="number" min="0.0001" max="1" step="0.0001"
               [(ngModel)]="stepKaynakTolerans" (ngModelChange)="stepAyarlariKaydet()"
               [disabled]="calisiyor || stepCalisiyor">
      </div>
      <div class="fa3-not" style="margin-top:4px;">
        0 ya da bos = sinirsiz (sadelestirme yapma). B-Rep'te her ucgen ~9 STEP satiri
        uretir; yuksek deger buyuk/yavas dosyaya, dusuk deger daha az detaya yol acar.
        Tessellated'de ucgen basina 1 satir oldugu icin genelde sinirsiz birakmak guvenlidir.
        Ayarlar tarayicinda saklanir, bir dahaki acilista hatirlanir.
      </div>
    </div>

    <div class="fa3-bar" *ngIf="calisiyor || yuzde > 0"><i [style.width.%]="yuzde"></i></div>
    <div class="fa3-durum">
      <span class="fa3-yuzde" *ngIf="calisiyor || yuzde > 0">%{{ yuzde }}</span>
      {{ durum }}
    </div>
    <div class="fa3-hata" *ngIf="hata">{{ hata }}</div>

    <div class="fa3-dugmeler">
      <button class="ui tiny blue button" style="flex:1"
              [disabled]="!dosya || calisiyor" (click)="uret()">
        <i class="icon cube"></i> 3D'ye Cevir
      </button>
      <button class="ui tiny grey button" *ngIf="calisiyor" (click)="iptal()">Iptal</button>
    </div>

    <div class="fa3-sonuc" *ngIf="sonucVar">
      <div class="fa3-sonuc-bas">Sonuc hazir</div>
      <div class="fa3-sonuc-bilgi">{{ sonucBilgi }}</div>

      <div class="fa3-dugmeler">
        <button class="ui tiny teal button" style="flex:1" *ngIf="eklendiMi" (click)="ekranaSigdir()">
          <i class="icon expand arrows alternate"></i> Ekranda goster
        </button>
        <button class="ui tiny teal button" style="flex:1" *ngIf="!eklendiMi"
                [disabled]="eklemeCalisiyor" (click)="sahneyeEkle()">
          <i class="icon plus"></i> Sahneye ekle
        </button>
        <button class="ui tiny violet button" style="flex:1"
                [disabled]="acmaCalisiyor" (click)="yeniSekmedeAc()">
          <i class="icon external alternate"></i> Yeni sekmede ac
        </button>
      </div>

      <div class="fa3-dugmeler">
        <button class="ui tiny grey button" style="flex:1" [disabled]="!stlBlob" (click)="indirStl()">
          <i class="icon download"></i> STL indir
        </button>
        <button class="ui tiny grey button" style="flex:1" [disabled]="!glbBlob" (click)="indirGlb()">
          <i class="icon download"></i> GLB indir
        </button>
      </div>

      <div class="fa3-dugmeler">
        <button class="ui tiny grey button" style="flex:1" [disabled]="!eklendiMi || stepCalisiyor" (click)="indirStep('brep')">
          <i class="icon download"></i> STEP indir (B-Rep)
        </button>
        <button class="ui tiny grey button" style="flex:1" [disabled]="!eklendiMi || stepCalisiyor" (click)="indirStep('tessellated')">
          <i class="icon download"></i> STEP indir (Tessellated)
        </button>
      </div>
    </div>

    <div class="fa3-not">
      Is akisi dokulu <b>GLB</b> uretir. <b>STL</b> secersen model tarayicida STL'e
      cevrilir — renk/doku tasimaz ama her CAD/dilimleyici acar. Sahneye eklenen ve
      indirilen STL, hedef boyuta (mm) olceklenmis ve tabana oturtulmus haldedir.
      <b>STEP</b> indirmek icin model once sahneye eklenmis olmali (mesh uzerinden uretilir);
      "Sahneye eklenecek" secenegini "Ekleme" birakirsan STEP butonlari pasif kalir.
      Agactaki ogeye sag tiklayip sonradan da "STL / STEP olarak indir" diyebilirsin.
    </div>
  </div>
  `
})
export class FikoAi3DDialogComponent implements OnDestroy {

  /** FikoThreeJsComponent (DialogFiko.ac -> parametreler.anaGosterim) */
  @Input() anaGosterim: any;

  dosya: File | null = null;
  onizlemeUrl: string | null = null;

  arkaPlanSil = true;
  dokuCozunurluk = 2048;
  hedefBoyutMm = 100;
  rastgeleSeed = true;

  /** Sahneye hangi format eklensin: 'glb' (renkli) | 'stl' (renksiz) | 'yok' */
  sahneFormat: 'glb' | 'stl' | 'yok' = 'stl';
  /** Uretim bitince dosyayi diske indir */
  stlIndir = true;
  glbIndir = false;
  stepIndir = false;
  stepModu: FikoStepModu = 'brep';
  stepCalisiyor = false;
  stepAyarlarAcik = false;
  /** 0 = sinirsiz (sadelestirme yapma). */
  stepHedefUcgenBrep = 25000;
  /** 0 = sinirsiz. */
  stepHedefUcgenTessellated = 0;
  stepKaynakTolerans = 0.001;
  private static readonly STEP_AYAR_ANAHTARI = 'fikoStepAyarlari';

  calisiyor = false;
  yuzde = 0;
  durum = '';
  hata = '';

  /** Uretim sonrasi elde tutulan sonuc (butonlar bunlari kullanir) */
  glbBlob: Blob | null = null;
  stlBlob: Blob | null = null;
  glbAd = '';
  stlAd = '';
  sonucBilgi = '';
  eklenenCizim: any = null;
  eklemeCalisiyor = false;
  acmaCalisiyor = false;

  get sonucVar(): boolean { return !!(this.glbBlob || this.stlBlob); }
  get eklendiMi(): boolean { return !!this.eklenenCizim; }

  private kontrol: AbortController | null = null;

  constructor(private cd: ChangeDetectorRef) {
    this.stepAyarlariYukle();
  }

  private stepAyarlariYukle(): void {
    try {
      const ham = localStorage.getItem(FikoAi3DDialogComponent.STEP_AYAR_ANAHTARI);
      if (!ham) return;
      const a = JSON.parse(ham);
      if (typeof a?.hedefUcgenBrep === 'number' && a.hedefUcgenBrep >= 0) this.stepHedefUcgenBrep = a.hedefUcgenBrep;
      if (typeof a?.hedefUcgenTessellated === 'number' && a.hedefUcgenTessellated >= 0) this.stepHedefUcgenTessellated = a.hedefUcgenTessellated;
      if (typeof a?.kaynakTolerans === 'number' && a.kaynakTolerans > 0) this.stepKaynakTolerans = a.kaynakTolerans;
    } catch { /* localStorage kapali olabilir / bozuk veri */ }
  }

  /** STEP ayarlarini tarayici localStorage'ina yazar (bir dahaki acilista hatirlanir). */
  stepAyarlariKaydet(): void {
    try {
      localStorage.setItem(FikoAi3DDialogComponent.STEP_AYAR_ANAHTARI, JSON.stringify({
        hedefUcgenBrep: this.stepHedefUcgenBrep,
        hedefUcgenTessellated: this.stepHedefUcgenTessellated,
        kaynakTolerans: this.stepKaynakTolerans
      }));
    } catch { /* yoksay */ }
  }

  ngOnDestroy(): void {
    // sendBeacon: normal fetch (kontrol.abort() ile tetiklenen) dialog kapanirken
    // component yok edilme sirasina gore yarida kalabilir; beacon garanti teslim eder.
    if (this.calisiyor) FikoComfyAPI.iptalBeaconGonder();
    this.kontrol?.abort();
    if (this.onizlemeUrl) URL.revokeObjectURL(this.onizlemeUrl);
  }

  /**
   * Sekme/pencere kapanirken ya da yenilenirken calisan bir uretim varsa ComfyUI'a
   * iptal sinyali yollar. `sendBeacon` kullanir cunku normal `fetch` (kontrol.abort()
   * ile tetiklenen) sayfa kapanirken yarida kesilebilir; `ngOnDestroy` de her zaman
   * garanti calismaz (sekme/pencere kapatma bir Angular yasam dongusu degildir).
   */
  @HostListener('window:beforeunload')
  @HostListener('window:pagehide')
  sayfaKapaniyor(): void {
    if (this.calisiyor) FikoComfyAPI.iptalBeaconGonder();
  }

  dosyaSec(): void {
    if (this.calisiyor) return;
    const inp = document.createElement('input');
    inp.type = 'file';
    inp.accept = 'image/png,image/jpeg,image/webp';
    inp.onchange = (e: any) => {
      const f: File = e.target?.files?.[0];
      if (!f) return;
      if (this.onizlemeUrl) URL.revokeObjectURL(this.onizlemeUrl);
      this.dosya = f;
      this.onizlemeUrl = URL.createObjectURL(f);
      this.hata = '';
      this.durum = '';
      this.yuzde = 0;
      this.cd.detectChanges();
    };
    inp.click();
  }

  iptal(): void {
    this.kontrol?.abort();
  }

  /** Buton/sahne icin hangi dosya kullanilacak (sahne formatina gore). */
  private secilenSonuc(): { blob: Blob; ad: string } | null {
    if (this.sahneFormat === 'glb' && this.glbBlob) return { blob: this.glbBlob, ad: this.glbAd };
    if (this.stlBlob) return { blob: this.stlBlob, ad: this.stlAd };
    if (this.glbBlob) return { blob: this.glbBlob, ad: this.glbAd };
    return null;
  }

  private dosyaBoyutu(b: Blob): string {
    const mb = b.size / (1024 * 1024);
    return mb >= 1 ? mb.toFixed(1) + ' MB' : Math.round(b.size / 1024) + ' KB';
  }

  /** Sonucu aktif sahneye ekler. */
  async sahneyeEkle(): Promise<void> {
    const s = this.secilenSonuc();
    if (!s || this.eklemeCalisiyor) return;
    this.eklemeCalisiyor = true;
    this.cd.detectChanges();
    try {
      this.eklenenCizim = await fikoAi3DSahneyeEkle(
        this.anaGosterim, s.blob, s.ad, this.hedefBoyutMm
      );
      this.hata = '';
    } catch (e: any) {
      this.hata = e?.message || String(e);
    } finally {
      this.eklemeCalisiyor = false;
      this.cd.detectChanges();
    }
  }

  /** Eklenen modeli ekrana sigdirir. */
  ekranaSigdir(): void {
    try {
      const sahne = this.anaGosterim?.sahneler?.[0];
      sahne?.ekranaSigdir?.(sahne);
      this.anaGosterim?.ciz?.();
    } catch { /* yoksay */ }
  }

  /**
   * Sonucu 3D goruntuleyicide (/🧩/🌌) YENI SEKMEDE acar.
   * Model yerel kasaya (IndexedDB) yazilir, yeni sekmeye sadece anahtar gider.
   */
  async yeniSekmedeAc(): Promise<void> {
    const s = this.secilenSonuc();
    if (!s || this.acmaCalisiyor) return;
    this.acmaCalisiyor = true;
    this.durum = 'Goruntuleyici icin hazirlaniyor…';
    this.cd.detectChanges();
    try {
      const kasa = await import('./fiko-ai-3d-kasa');
      const anahtar = await kasa.fikoAi3DKasayaKoy(s.blob, s.ad, this.hedefBoyutMm);
      window.open(kasa.fikoAi3DGoruntuleyiciAdres(anahtar), '_blank');
      this.durum = 'Yeni sekmede aciliyor: ' + s.ad;
    } catch (e: any) {
      this.hata = 'Yeni sekmede acilamadi: ' + (e?.message || e);
    } finally {
      this.acmaCalisiyor = false;
      this.cd.detectChanges();
    }
  }

  indirStl(): void { if (this.stlBlob) fikoDosyaIndir(this.stlBlob, this.stlAd); }
  indirGlb(): void { if (this.glbBlob) fikoDosyaIndir(this.glbBlob, this.glbAd); }

  /** Sahneye eklenmis objeyi STEP olarak disa aktarir (mesh'ten uretilir, bu yuzden once eklenmis olmasi sart). */
  async indirStep(mod: FikoStepModu): Promise<void> {
    if (!this.eklenenCizim || this.stepCalisiyor) return;
    this.stepCalisiyor = true;
    this.hata = '';
    this.durum = 'STEP hazirlaniyor (' + (mod === 'brep' ? 'B-Rep' : 'Tessellated') + ')…';
    this.cd.detectChanges();
    try {
      const hedefUcgenAyari = mod === 'brep' ? this.stepHedefUcgenBrep : this.stepHedefUcgenTessellated;
      await fikoObjeyiStepIndir(this.eklenenCizim, mod, this.eklenenCizim.name, {
        // 0/bos = kullanicinin "sinirsiz" secimi — undefined gecince modulun kendi
        // varsayilani (B-Rep icin 25000) da devre disi kalir, tam mesh gider.
        hedefUcgen: hedefUcgenAyari > 0 ? hedefUcgenAyari : undefined,
        kaynakTolerans: this.stepKaynakTolerans > 0 ? this.stepKaynakTolerans : undefined,
        ilerleme: (mesaj: string, yuzde: number) => {
          this.durum = mesaj + '…';
          this.yuzde = yuzde;
          this.cd.detectChanges();
        }
      });
    } catch (e: any) {
      this.hata = 'STEP olarak aktarilamadi: ' + (e?.message || e);
    } finally {
      this.stepCalisiyor = false;
      this.durum = '';
      this.cd.detectChanges();
    }
  }

  async uret(): Promise<void> {
    if (!this.dosya || this.calisiyor) return;

    this.calisiyor = true;
    this.hata = '';
    this.yuzde = 1;
    this.durum = 'Baslatiliyor…';
    this.glbBlob = null;
    this.stlBlob = null;
    this.glbAd = '';
    this.stlAd = '';
    this.sonucBilgi = '';
    this.eklenenCizim = null;
    this.kontrol = new AbortController();
    this.cd.detectChanges();

    try {
      const sonuc = await FikoComfyAPI.uret(this.dosya, {
        arkaPlanSil: this.arkaPlanSil,
        dokuCozunurluk: this.dokuCozunurluk,
        rastgeleSeed: this.rastgeleSeed,
        iptalSinyali: this.kontrol.signal,
        ilerleme: (mesaj, y) => {
          this.durum = mesaj;
          if (y >= 0) this.yuzde = Math.round(y);
          this.cd.detectChanges();
        }
      });

      const glbMi = sonuc.uzanti !== 'stl';
      const stlAdi = fikoStlAdi(sonuc.ad);

      // STL gerekiyorsa (sahneye eklemek, indirmek veya buton icin) burada uretilir.
      this.durum = 'STL üretiliyor…';
      this.cd.detectChanges();
      const stlBlob = glbMi
        ? await fikoGlbBlobundanStl(sonuc.blob, this.hedefBoyutMm)
        : sonuc.blob;

      this.glbBlob = glbMi ? sonuc.blob : null;
      this.glbAd = glbMi ? sonuc.ad : '';
      this.stlBlob = stlBlob;
      this.stlAd = stlAdi;
      this.sonucBilgi = this.dosyaBoyutu(stlBlob) + ' STL'
        + (this.glbBlob ? ' · ' + this.dosyaBoyutu(this.glbBlob) + ' GLB' : '')
        + ' · hedef ' + this.hedefBoyutMm + ' mm';

      if (this.sahneFormat !== 'yok') {
        this.durum = 'Sahneye ekleniyor…';
        this.cd.detectChanges();
        await this.sahneyeEkle();
      }

      if (this.stlIndir) fikoDosyaIndir(stlBlob, stlAdi);
      if (this.glbIndir && this.glbBlob) fikoDosyaIndir(this.glbBlob, this.glbAd);
      if (this.stepIndir && this.eklenenCizim) await this.indirStep(this.stepModu);

      this.yuzde = 100;
      this.durum = this.eklendiMi
        ? 'Eklendi: ' + (this.eklenenCizim?.name || stlAdi)
        : 'Hazir: ' + stlAdi;
    } catch (e: any) {
      this.hata = e?.message || String(e);
      this.durum = '';
    } finally {
      this.calisiyor = false;
      this.kontrol = null;
      this.cd.detectChanges();
    }
  }
}
